import { FC } from "react";

import { HighlightCard as HighlightCardUI } from "@jti/ui/components/HighlightCard";

import { highlightCardInputs } from "./HighlightCard.builder";

type HighlightCardBuilderProps = BuilderComponentProps<
  typeof highlightCardInputs
>;

export const HighlightCard: FC<HighlightCardBuilderProps> = ({
  buttonText,
  description,
  imageUrl,
  title,
  linkUrl,
  theme,
  leftBadgeText,
  rightBadgeText,
  alt,
}) => {
  return (
    <HighlightCardUI
      buttonText={buttonText}
      description={description}
      imageUrl={imageUrl}
      title={title}
      alt={alt}
      linkUrl={linkUrl}
      theme={theme}
      leftBadgeText={leftBadgeText}
      rightBadgeText={rightBadgeText}
    />
  );
};
